
























































































































import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import TextMonthChangePicker from "../components/common/TextMonthChangePicker.vue";
import BaseTable, {
  StringKeyObject
} from "@/components/common/MergeBaseTable.vue";
import RightSideMenu from "@/components/common/RightSideMenu.vue";
import AxiosMixin from "../mixins/axiosMixin";
import { HeaderWidthItem, ObjectId, dateJp } from "@/types";
import { Ref } from "vue-property-decorator";
import LoadingDialog from "../components/common/LoadingDialog.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import OutputCsvDialog, {
  CsvOutputItem
} from "../components/careMerge/OutputCsvDialog.vue";
import SelectFilter, { ColumnKey } from "@/components/common/SelectFilter.vue";
import ReCalcResultDialog from "@/components/common/ReCalcResultDialog.vue";
import MonthPickerDialog from "@/components/common/MonthPickerDialog.vue";
import SelectDialog from "@/components/common/SelectDialog.vue";
import { getDefaultMonth } from "@/types";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    TextMonthChangePicker,
    BaseTable,
    LoadingDialog,
    OutputCsvDialog,
    RightSideMenu,
    SelectFilter,
    ReCalcResultDialog,
    MonthPickerDialog,
    SelectDialog
  }
})
export default class CareMerge extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;

  @Ref("csvDialog") private readonly csvDialog!: OutputCsvDialog;

  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    localStorage.setItem("yearmonth", yearmonth);
    this.setYearmonth(yearmonth);
  }
  private searchYM = "";

  @Ref("reCalcReCalcResultDialog")
  private readonly reCalcReCalcResultDialog!: ReCalcResultDialog;

  private historys = [];
  private isActiveHistory = false;
  private selectHistory: { id: number; updated_at?: string } = {
    id: 0
  };

  private headerItems: HeaderWidthItem[] = [
    {
      value: "edit",
      text: "編集",
      width: "80px"
    },
    {
      value: "history",
      text: "履歴",
      width: "80px"
    },
    {
      value: "is_printed",
      text: "明細データ確定済",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_printed", val)
    },
    {
      value: "is_exec",
      text: "処理済日",
      width: "96px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_exec", val)
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px",
      filter: (val: object) => this.columnFilter("insured_no", val)
    },
    {
      value: "name",
      text: "氏名",
      width: "120px",
      filter: (val: object) => this.columnFilter("name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "120px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_no", val)
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "140px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_name", val)
    },
    {
      value: "disp_yearmonth",
      text: "サービス提供年月",
      width: "108px"
    }
  ];

  //------------------------------------------
  // SelectFilterの選択肢
  //------------------------------------------
  private get columnKeys(): ColumnKey[] {
    return this.headerItems
      .filter(hditm => {
        return hditm.filter != null;
      })
      .map(hditm => {
        let type = SelectFilter.FILTER_TYPE_EDIT;
        if (hditm.filterType != null) {
          type = hditm.filterType;
        }
        let selectable = null;
        if (
          hditm.filterType === SelectFilter.FILTER_TYPE_LIST ||
          hditm.filterType === SelectFilter.FILTER_TYPE_EDIT_LIST
        ) {
          //選択肢一覧作成
          selectable = this.tableItems
            .map(itm => {
              const txt = (itm as any)[hditm.value];
              return txt === "" ? SelectFilter.NO_DATA : txt;
            })
            .filter((val, idx, arr) => {
              return arr.indexOf(val) === idx;
            });
          //NO_DATAラベルを一覧の先頭に移動
          const idx = selectable.indexOf(SelectFilter.NO_DATA);
          if (idx > 0) {
            this.moveAt(selectable, idx, 0);
          }
        }
        const fkey: ColumnKey = {
          type: type,
          key: hditm.value,
          text: hditm.text,
          selectable: selectable
        };
        return fkey;
      });
  }

  //------------------------------------------
  // カラムフィルター
  //------------------------------------------
  private columnFilter(key: string, val: object) {
    const bret = this.selectFilter.isMatch(key, val);

    // テーブル更新
    if (this.baseTable) {
      this.baseTable.handle();
    }
    return bret;
  }

  private tableItems: object[] = [];

  private noExecs: object[] = []; //未処理データs
  private noExecCount = 0; //未処理件数
  private message = ""; //メッセージ
  private isActiveMonthPicker = false;

  private objectIds: ObjectId[] = []; //選択対象ID

  mounted() {
    const ym = localStorage.getItem("yearmonth");
    this.yearmonth = ym ? String(ym) : getDefaultMonth().substr(0, 7);

    // 画面復帰設定（チェックボックス、フィルタ条件）
    if (!this.$route.query.st) {
      this.baseTable.clearAllCheck();
      this.selectFilter.clearAll();
    } else {
      this.baseTable.restoreStorage();
      this.selectFilter.restoreStorage();
    }
    // 画面更新
    this.updateData();
  }

  //------------------------------------------
  //データ更新
  //------------------------------------------
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/care/specification/get",
      {
        yearmonth: this.yearmonth.replace("-", "")
      },
      res => {
        this.searchYM = this.yearmonth.replace("-", ""); // 検索年月保持(Excelファイル名に使用)
        this.tableItems = res.data.specifications;
        this.noExecs = res.data.no_outputs;
        this.noExecCount = res.data.count;
        this.$router.replace(`/care/merge?st=1`).catch(err => err);
        this.$nextTick(() => {
          this.baseTable.restoreStorage();
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  //------------------------------------------
  //検索
  //------------------------------------------
  private search() {
    this.baseTable.clearAllCheck();
    this.updateData();
  }

  //------------------------------------------
  //再集計
  //------------------------------------------
  private closeMonthPicker() {
    this.isActiveMonthPicker = false;
  }
  private cleckReCalc(object: ObjectId[]) {
    if (object.length == 0) {
      this.isActiveMonthPicker = true;
    } else {
      this.reCalc(object);
    }
  }
  private reCalcResultReload() {
    this.updateData();
  }

  private reCalcAll(yearmonth: string) {
    //確認
    if (
      !confirm(
        "対象年月の確定済かつ請求履歴未確定データを再集計します。" +
          "\n" +
          "また、編集したデータはリセットされ最新の状態に更新されます。" +
          "\n" +
          "よろしいですか？"
      )
    ) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/office/recalc/result",
      {
        ins_type: 2,
        all: true,
        multi_month: false,
        yearmonth: yearmonth,
        yearmonths: [],
        select_items: []
      },
      res => {
        this.message = res.data.result_message;
        this.isActiveMonthPicker = false;
        this.reCalcReCalcResultDialog.open();
        this.baseTable.selectItems = this.baseTable.items;
      }
    );
  }
  private reCalc(object: ObjectId[]) {
    //確認
    if (
      !confirm(
        "選択されたデータを再集計します。" +
          "\n" +
          "また、編集したデータはリセットされ最新の状態に更新されます。" +
          "\n" +
          "よろしいですか？"
      )
    ) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/office/recalc/result",
      {
        ins_type: 2,
        all: false,
        multi_month: false,
        yearmonth: this.yearmonth,
        yearmonths: [],
        select_items: object
      },
      res => {
        this.message = res.data.result_message;
        this.reCalcReCalcResultDialog.open();
      }
    );
  }
  private get Message() {
    return this.message;
  }

  //------------------------------------------
  //結果ダウンロード
  //------------------------------------------
  private downloadResult() {
    this.postJsonBlobResCheck(
      window.base_url + "/api/office/recalc/downloadResult",
      {
        message: this.message
      },
      res => {
        const fileName = "downloadReCalcResult.txt";
        this.downloadMessageTxt(res.data, fileName);
      }
    );
  }
  private downloadMessageTxt(blobable: Blob, fileName: string): void {
    if (!blobable.size) return;
    const blob = new Blob([blobable]);
    const a = document.createElement("a");
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.click();
  }

  //------------------------------------------
  //明細書出力
  //------------------------------------------
  private doneSpecification(objectIds: ObjectId[], isPreview = false) {
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/care/specification",
      {
        ids: objectIds.map(objectId => objectId.id),
        is_preview: false
      },
      res => {
        window.open(res.data.pdf_path);
      }
    );
  }

  //------------------------------------------
  //請求書出力
  //------------------------------------------
  private doneInsinvoice(objectIds: ObjectId[], isPreview = false) {
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/care/insinvoice",
      {
        ids: objectIds.map(objectId => objectId.id),
        is_preview: false
      },
      res => {
        window.open(res.data.pdf_path);
      }
    );
  }

  //------------------------------------------
  //明細書・請求書出力
  //------------------------------------------
  private doneAll(objectIds: ObjectId[], isPreview = false) {
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/care/all",
      {
        ids: objectIds.map(objectId => objectId.id),
        is_preview: false
      },
      res => {
        window.open(res.data.pdf_path);
      }
    );
  }

  //------------------------------------------
  //確定
  //------------------------------------------
  private checked(objectIds: ObjectId[]) {
    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/care/specification/checked",
      {
        ids: ids
      },
      () => {
        this.updateData();
      }
    );
  }

  //------------------------------------------
  //確定キャンセル
  //------------------------------------------
  private cancel(objectIds: ObjectId[]) {
    const ids = [0];
    objectIds.forEach(objectId => {
      ids.push(objectId.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/care/specification/cancel",
      {
        ids: ids
      },
      () => {
        this.updateData();
      }
    );
  }

  //------------------------------------------
  //ダウンロード
  //------------------------------------------
  private download(objectIds: ObjectId[]) {
    const ids = objectIds.map(item => item.id);
    const param = {
      yearmonth: this.searchYM,
      ids: ids
    };
    const yy = this.yearmonth.split("-")[0];
    const mm = this.yearmonth.split("-")[1];
    const fname = `介護請求一覧（${yy}年${mm}月分）_${this.dateFormat(
      new Date()
    )}.xlsx`;

    this.postJsonBlobRes(
      window.base_url + "/api/office/care/specification/excel",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  // 日付フォーマット(yyyyMMdd_HHmmss)
  private dateFormat(d: Date) {
    const ymd = `${d.getFullYear()}${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${d
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    const hms = `${d
      .getHours()
      .toString()
      .padStart(2, "0")}${d
      .getMinutes()
      .toString()
      .padStart(2, "0")}${d
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;
    return `${ymd}_${hms}`;
  }

  //------------------------------------------
  //編集画面に遷移
  //------------------------------------------
  private edit(item: ObjectId) {
    this.$router.push({
      path:
        "/care/edit/" +
        item.patient_id +
        "?tab=specification&specification_id=" +
        item.id +
        "&yearmonth=" +
        item.yearmonth.replace("-", "")
    });
  }

  //------------------------------------------
  //履歴取得する
  //------------------------------------------
  private history(item: StringKeyObject) {
    this.postJsonCheck(
      window.base_url + "/api/office/care/specification/get_historys",
      {
        patient_id: item.patient_id,
        yearmonth: String(item.yearmonth).replace("-", ""),
        insured_no: item.insured_no,
        insurance_no: item.insurance_no,
        insured_care_status: item.insured_care_status
      },
      res => {
        this.historys = res.data.historys;
        this.isActiveHistory = true;
      }
    );
  }

  private get OnChangeHistory() {
    return this.historys;
  }

  private onSelecHistory(item: { id: number; updated_at: string }) {
    this.selectHistory = item;
    this.isActiveHistory = false;
    this.historyPdf(item);
  }

  private onCancelHistory() {
    this.isActiveHistory = false;
  }

  //------------------------------------------
  //履歴用PDF出力
  //------------------------------------------
  private historyPdf(item: { id: number; updated_at: string }) {
    this.postJsonCheck(
      window.base_url + "/api/office/pdf/care/specification",
      {
        ids: [item.id],
        history: 1
      },
      res => {
        window.open(res.data.pdf_path);
      }
    );
  }

  //------------------------------------------
  //CSVダイアログ起動
  //------------------------------------------
  private openCsvDialog(objectIds: ObjectId[]) {
    this.objectIds = objectIds;
    this.csvDialog.open();
  }

  //------------------------------------------
  //最終出力処理
  //------------------------------------------
  private output(item: CsvOutputItem) {
    if (confirm("処理済みにしますか？")) {
      this.checked(this.objectIds);
      this.execChecked(this.objectIds);
    }
    const map = new Map<string, number[]>();
    this.objectIds.forEach(objectId => {
      if (map.has(objectId.yearmonth)) {
        const ids = map.get(objectId.yearmonth);
        ids?.push(objectId.id);
      } else {
        map.set(objectId.yearmonth, [objectId.id]);
      }
    });
    map.forEach(value => {
      this.postJsonBlobResCheck(
        window.base_url + "/api/office/care/csv/output",
        {
          ids: value,
          media_class: String(item.mediaClass),
          target_month: item.targetYM.replace("-", "")
        },
        res => {
          // 出力ファイル名取得
          const filename = res.headers["x-data-filename"];
          if (!filename) {
            alert("ファイル名の取得に失敗しました。");
          }
          // CSVファイル保存
          const blob = new Blob([res.data]);
          const a = document.createElement("a");
          // IBR-519 【介護請求管理】伝送CSVのファイル名規則変更（改善要望⑤）
          // a.download = this.getCsvFilename(item.mediaClass);
          a.download = filename;
          a.href = URL.createObjectURL(blob);
          a.click();
        }
      );
    });
  }

  private getCsvFilename(mediaClass: number) {
    let prefix: string;
    switch (mediaClass) {
      case 1:
        prefix = "i";
        break;
      case 2:
        prefix = "m";
        break;
      case 4:
        prefix = "f";
        break;
      default:
        prefix = "i";
    }
    const now = new Date();
    const jpstr = dateJp(now);
    const yymm = jpstr.substr(2, 2) + jpstr.substr(5, 2);
    // 乱数用
    const timestamp = now.getTime();
    const suffix = timestamp.toString(36).slice(-3);

    return `${prefix}${yymm}${suffix}.csv`;
  }

  //------------------------------------------
  //処理済みチェック
  //------------------------------------------
  private execChecked(objectIds: ObjectId[]) {
    const ids = objectIds.map(objectId => objectId.id);
    this.postJsonCheck(
      window.base_url + "/api/office/care/insinvoice/checked",
      {
        ids: ids
      },
      () => {
        this.updateData();
      }
    );
  }

  private changeYear(yearmonth: string) {
    this.yearmonth = yearmonth;
    this.updateData();
  }

  //------------------------------------------
  // 配列要素の移動
  //------------------------------------------
  private moveAt(array: object[], idx: number, at: number) {
    if (idx === at || idx > array.length - 1 || at > array.length - 1) {
      return;
    }
    const value = array[idx];
    const tail = array.slice(idx + 1);
    array.splice(idx);
    Array.prototype.push.apply(array, tail);
    array.splice(at, 0, value);
  }
}
